import React, { useEffect, useState } from 'react';
import './SignIn.css';
import { Link } from 'react-router-dom';
import { auth } from '../firebase'
import { onAuthStateChanged, createUserWithEmailAndPassword, signInWithEmailAndPassword, updateProfile } from 'firebase/auth'

export default function SignIn() {
  const [showPassword, setShowPassword] = useState(false);
  const [method, setmethod] = useState('Login');
  const [loading, setloading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: 'Fletcher',
    lastName: '',
    email: '',
    password: '',
    agreeTerms: true,
  });

  useEffect(() => {
    onAuthStateChanged(auth, (u) => {
      if (u) {
        window.location.href = '../';
      }
    })
  }, [])

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const SignUp = async () => {
    if (formData.firstName && formData.lastName && formData.email && formData.agreeTerms && formData.password) {
      setloading(true);
      let userCredential = await createUserWithEmailAndPassword(auth, formData.email, formData.password);
      let user = userCredential.user;
      await updateProfile(user, {
        displayName: formData.firstName + ' ' + formData.lastName
      }).then(() => {
        setloading(false);
        window.alert('Account was successfully created.')
        window.location.href = '../';
      }).catch((e) => {
        console.log(e);
        window.alert(e.code)
        setloading(false);
      })
    } else {
      window.alert('Some feild is required!')
    }
  };
  const Login = async () => {
    if (formData.email && formData.agreeTerms && formData.password) {
      setloading(true);
      await signInWithEmailAndPassword(auth, formData.email, formData.password).then(() => {
        setloading(false);
        window.alert('Login account successfully.')
        window.location.href = '../';
      }).catch((e) => {
        console.log(e);
        setloading(false);
        window.alert(e.code)
      })
    } else {
      window.alert('Some feild is required!')
    }
  };
  return (
    <div className="signin-page">
      <div className="signin-card">
        {/* Left Banner Section */}
        <div className="signin-banner">
          <div className="banner-header">
            <span className="logo-text">MMao</span>
            <Link to={'/'} className="back-btn">Back to website &rarr;</Link>
          </div>

          <div className="banner-content">
            <h2 className="banner-slogan">
              Learn Smart,<br /> Build Your Dream Future
            </h2>
            <div className="pagination-dots">
              <span className="dot"></span>
              <span className="dot"></span>
              <span className="dot active"></span>
            </div>
          </div>
        </div>

        {/* Right Form Section */}
        <div className="signin-form-section">
          <div className="form-header">
            <h1>{method === 'Login' ? 'Login account' : 'Create an account'}</h1>
            {method === 'SignUp' && <p className="login-prompt">
              Already have an account? <button onClick={() => { setmethod('Login') }}>Log in</button>
            </p>}
            {method === 'Login' && <p className="login-prompt">
              New user? <button onClick={() => { setmethod('SignUp') }}>Sign Up</button>
            </p>}
          </div>

          <div className="signin-form">
            {method === 'SignUp' && <div className="name-row">
              <div className="input-group">
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder="First name"
                  required
                />
              </div>
              <div className="input-group">
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Last name"
                />
              </div>
            </div>}

            <div className="input-group">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email"
                required
              />
            </div>

            <div className="input-group password-group">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter your password"
                required
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                aria-label="Toggle password visibility"
              >
                {showPassword ? <i class="ri-eye-close-line"></i> : <i class="ri-eye-line"></i>}
              </button>
            </div>

            <div className="terms-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="agreeTerms"
                  checked={formData.agreeTerms}
                  onChange={handleChange}
                />
                <span className="checkmark"></span>
                I agree to the <a href="#terms">Terms & Conditions</a>
              </label>
            </div>

            {method === 'SignUp' && <button onClick={() => { SignUp() }} type="submit" className="submit-btn">
              {loading && <div className='whiteloading' style={{ marginRight: 9 }}></div>}
              Create account
            </button>}
            {method === 'Login' && <button onClick={() => { Login() }} type="submit" className="submit-btn">
              {loading && <div className='whiteloading' style={{ marginRight: 9 }}></div>}
              Login
            </button>}

            <div className="divider">
              <span>Or register with</span>
            </div>

            <div className="social-buttons">
              <button type="button" className="social-btn google-btn">
                <i class="ri-google-fill"></i>
                Google
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}